import { VideoMeetingChat } from "./VideoMeetingChat";
import { useChatVisibility } from "@platform/hooks/useChatVisibility";
import { useFetchUserCircles } from "@core/features/circle";
import { usePlatformStore } from "@platform/store";

export function VideoMeetingChatContainer() {
  const user = usePlatformStore((s) => s.user);
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;
  const { shouldShowChat, isLoading } = useChatVisibility({ userCircles });

  // Don't render chat if disabled or still loading
  if (isLoading || !shouldShowChat) {
    return null;
  }

  return <VideoMeetingChat />;
}

export default VideoMeetingChatContainer;
